import AdacaAPI from '..';

export type PolicyArgs = {
  nif: string;
  licensePlate: string;
  insuranceCompany?: string;
  identifier?: string;
  phone?: string;
};

export interface IPolicyResponse {
  identificador?: string;
  codigo: string;
  descripcion: string;
  codigoPoliza: string;
  tomador: string;
  intervencionAnterior?: string;
  fechaIntervencion?: Date;
  enCurso?: boolean;
}

export const getPolicy = async (args?: PolicyArgs) => {
  if (!args) throw new Error('Error');
  const { data } = await AdacaAPI.get<IPolicyResponse>(`/Policy`, {
    params: {
      ...args,
    },
  });
  return data;
};

export const getPolicyOnDemand = async (args?: PolicyArgs) => {
  if (!args) throw new Error('Error');
  const { data } = await AdacaAPI.get<IPolicyResponse>('/Policy/on-demand', {
    params: {
      ...args,
    },
  });
  return data;
};

/** Obtiene las coberturas que aplican a la póliza correspondiente al expediente de una intervención. */
const getPolicyCoverages = async (intervention: string) => {
  if (!intervention) throw new Error('Error');
  const { data } = await AdacaAPI.get<string[]>(`/Policy/coverages/${intervention}`);
  return data;
};

export { getPolicyCoverages };
